import {DOCUMENT} from '@angular/common';
import {ActivatedRoute, Router} from '@angular/router';
import {Component, Inject} from '@angular/core';
import {ApiServiceService} from '../api-service.service';
import {HttpClient} from '@angular/common/http';

@Component({
    selector: 'app-register',
    templateUrl: './register.component.html',
    styleUrls: ['./register.component.css'],
    providers: [ApiServiceService]
})
export class RegisterComponent {

    mobileErrorMsg: string;
    mobileError = false;
    errorMsgRange = false;
    errorEmailRange = false;
    errorMsgRange2 = false;
    phoneno: string;
    name: string;
    email: string;
    loan_amt: any;

    constructor(private route: ActivatedRoute, private http: HttpClient, private ref: ApiServiceService, private router: Router,
                @Inject(DOCUMENT) private document: any) {
    }

    onNameInput(event) {
        this.name = event.target.value.replace(/[^A-Za-z ]+/, '');
    }

    onPhoneInput(event) {
        this.mobileError = false;
        if (event.target.value.length == 10) {
            if (event.target.value.match(/[6789][0-9]{9}/)) {
                this.phoneno = event.target.value.replace(/[^0-9]+/, '');
            } else {
                this.mobileError = true;
                this.mobileErrorMsg = 'Please provide a valid mobile number';
                return false;
            }
        }
    }

    registerFinzy(formdata) {
        this.mobileError = false;
        this.errorMsgRange = false;
        this.errorEmailRange = false;
        this.errorMsgRange2 = false;
        if ((formdata.loan_amt % 1000 == 0) && (formdata.loan_amt != 0) && (formdata.loan_amt != null && formdata.loan_amt != '' && formdata.loan_amt != undefined)) {
            if ((formdata.loan_amt >= 50000) && (formdata.loan_amt <= 500000)) {
                if (formdata.phoneno.length == 10 && (formdata.phoneno != null && formdata.phoneno != '' && formdata.phoneno != undefined)) {
                    if (formdata.email == null || formdata.email == '' || formdata.email == undefined || !(formdata.email.match(/^[A-Za-z0-9_.]+@[a-zA-Z_]+?\.[a-zA-Z]{2,3}$/))) {
                        this.errorEmailRange = true;
                        return false;
                    } else {
                        this.http.post<any>(this.ref.baseURL() + 'generateShortUrl', {
                            name: formdata.name,
                            mobile_no: formdata.phoneno,
                            email: formdata.email,
                            loan_amount: formdata.loan_amt,
                            loan_purpose: 'Travel/Holiday'
                        }).subscribe((result) => {
                            if (result.status == 'success') {
                                this.router.navigate(['/registrationsuccess/' + result.shortURL]);
                            }

                        });
                    }

                } else {
                    this.mobileError = true;
                    this.mobileErrorMsg = 'Please provide a valid mobile number';
                    return false;
                }
            } else {
                this.errorMsgRange = true;
                return false;
            }
        } else {
            this.errorMsgRange2 = true;
            return false;
        }
    }
}
